import React from 'react'

interface IProp {
  component: any
}

class SampleCalculatorComponent extends React.Component<IProp, any> {
  constructor (props: IProp) {
    super(props)
  }

  render() {
    const { component } = this.props
    return <div>{component.value} ({component.result.replace(/<\/?[^>]+(>|$)/g, "")})</div>
  }
}

export default SampleCalculatorComponent